const celebrationFilters = [
    { label: 'All', value: 'all' },
    { label: 'Birthday', value: 'birthday' },
    { label: 'Anniversary', value: 'anniversary' },
];

export default celebrationFilters;
